export const borderWidths = {
  "none": "0",
  "xs": "1px",
  "sm": "2px",
  "md": "3px",
  "lg": "4px",
  "xl": "6px"
};